import {
  setComponentSettings as publicSetComponentSettings,
  getComponentSettings as publicGetComponentSettings,
  setGlobalSettings as publicSetGlobalSettings,
  getGlobalSettings as publicGetGlobalSettings,
} from './app-settings-v1-settings-app-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const setComponentSettings: MaybeContext<
  BuildRESTFunction<typeof publicSetComponentSettings> &
    typeof publicSetComponentSettings
> = /*#__PURE__*/ createRESTModule(publicSetComponentSettings);
export const getComponentSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetComponentSettings> &
    typeof publicGetComponentSettings
> = /*#__PURE__*/ createRESTModule(publicGetComponentSettings);
export const setGlobalSettings: MaybeContext<
  BuildRESTFunction<typeof publicSetGlobalSettings> &
    typeof publicSetGlobalSettings
> = /*#__PURE__*/ createRESTModule(publicSetGlobalSettings);
export const getGlobalSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetGlobalSettings> &
    typeof publicGetGlobalSettings
> = /*#__PURE__*/ createRESTModule(publicGetGlobalSettings);

export {
  State,
  Host,
  Scope,
} from './app-settings-v1-settings-app-settings.universal.js';
export {
  AppSettings,
  SetComponentSettingsRequest,
  TranslatedLanguage,
  LanguageKey,
  SetComponentSettingsResponse,
  SetComponentSettingsForMigrationRequest,
  SetComponentSettingsForMigrationResponse,
  GetComponentSettingsRequest,
  GetComponentSettingsResponse,
  BulkGetComponentSettingsRequest,
  BulkGetComponentSettingsResponse,
  ComponentSettings,
  SetGlobalSettingsRequest,
  SetComponentSettingsItem,
  SetGlobalSettingsResponse,
  GetGlobalSettingsRequest,
  GetGlobalSettingsResponse,
  GetComponentSettingsItem,
  SetGlobalSettingsForMigrationRequest,
  SetGlobalSettingsForMigrationResponse,
  GetGlobalSettingsForMigrationRequest,
  GetGlobalSettingsForMigrationResponse,
  GetRequest,
  GetResponse,
  SetRequest,
  SetResponse,
  UpdateRequest,
  UpdateResponse,
  SetComponentSettingsOptions,
  GetComponentSettingsOptions,
  SetGlobalSettingsOptions,
  GetGlobalSettingsOptions,
} from './app-settings-v1-settings-app-settings.universal.js';
export {
  StateWithLiterals,
  HostWithLiterals,
  ScopeWithLiterals,
} from './app-settings-v1-settings-app-settings.universal.js';
